import { Select, SelectProps } from "antd";
import React from "react";

const LookupTypeDropdown = ({ ...props }: Partial<SelectProps>) => {
  const loginType = localStorage.getItem("LOGINTYPE");

  return (
    <Select {...props}>
      <Select.Option value="name">Name</Select.Option>
      <Select.Option value="SOUNDEX">Soundex</Select.Option>
      <Select.Option value="CASE">Case</Select.Option>
      <Select.Option value="DOB">Birth Date</Select.Option>
      <Select.Option value="TKT">Ticket</Select.Option>
      <Select.Option value="LICPLATE">License Plate</Select.Option>
      <Select.Option value="INC">Incident</Select.Option>
      {loginType === "A" && (
        <>
          <Select.Option value="SSN">Social Security Num.</Select.Option>
          <Select.Option value="FID">Federal ID</Select.Option>
          <Select.Option value="WAR">Warrant</Select.Option>
        </>
      )}
    </Select>
  );
};

export default LookupTypeDropdown;
